<template>
  <div>
    <Table border :columns="columns1" :data="showData.list"></Table>
    <div class="page-con">
      <Page show-total :total="showData.total" :page-size="10" @on-change="chagepage" :current="showData.pageNum" show-elevator class="pull-right" />
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      showDeletewin: false,  //显示删除提示
      param: {              //查询条件
        roleName: '',
      },
      showData: {           //列表容器
        pageNum: 1
      },
      columns1: [           //表头
        {title: '设备号',key: 'devicenum'},
        {title: '车辆编号',key: 'carnum'},
        {title: '设备号状态', align: 'center', key: 'state',
          render: (h, params) => {
            return h('div', this.getDeviceType(params.row.state))
          }
        },
        {title: '对应订单号',key: 'salenum'},
        {title: '所在车行',key: 'name'},
        {title: '状态', align: 'center', key: 'synstate',
          render: (h, params) => {
            return h('div', this.getSynType(params.row.synstate))
          }
        }
      ]
    }
  },
  activated() {
    this.getList ()
  },
  mounted () {
    this.getList ()
  },
  methods: {
    chagepage (current) {
      this.showData.pageNum = current
      this.getList()
    },
    getList () {   //获取列表
      this.$Loading.start()
      this.$axios.get('/device/list/' + this.showData.pageNum)
      .then(function (response) {
        if (response.data.success) {
          this.showData = response.data.data
          this.$Loading.finish()
        } else {
          this.$Message.error(response.data.errMsg)
          this.$Loading.error()
        }
      }.bind(this))
    },
    getDeviceType(type) {
      if(type == 1) {
        return '未绑定'
      } else if(type == 2) {
        return '已绑定'
      } else if(type == 3) {
        return '已作废'
      }
    },
    getSynType(type) {
      if(type == 1) {
        return '未验证'
      } else if(type == 2) {
        return '已验证'
      } else if(type == 3) {
        return '已作废'
      }
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/views/device/list.vue